<template>
  <div style="display: flex; align-items: center;">
    <div style="padding: 0 1rem 0 1rem">
      <translate>AboutMe.sort.by</translate>
    </div>
    <b-select v-model="localSortField" style="padding: 0 1rem 0 1rem">
      <option
        :value="value.field"
        v-for="value in sortFields"
        :key="`${resourceType}.${value.field}`"
      >
        <translate>{{value.label}}</translate>
      </option>
    </b-select>
    <b-select v-model="localSortOrder">
      <option value="ASC">
        <translate>AboutMe.sort.order.ASC</translate>
      </option>
      <option translate value="DESC">
        <translate>AboutMe.sort.order.DESC</translate>
      </option>
    </b-select>
  </div>
</template>

<script>

export default {
  name: 'fob-aboutme-list-sort',
  props: ['resourceType', 'sortField', 'sortFields', 'sortOrder'],
  computed: {
    localSortField: {
      get () {
        return this.sortField
      },
      set (newSortField) {
        this.onSortFieldChange(newSortField)
        return newSortField
      }
    },
    localSortOrder: {
      get () {
        return this.sortOrder
      },
      set (newSortOrder) {
        this.onSortOrderChange(newSortOrder)
        return newSortOrder
      }
    }
  },
  methods: {
    onSortFieldChange (sortField) {
      this.$emit('update:sortFieldAboutMe', sortField)
    },
    onSortOrderChange (sortOrder) {
      this.$emit('update:sortOrderAboutMe', sortOrder)
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/aboutme/AboutMeListSort.vue